import { render, staticRenderFns } from "./RoleContainer.vue?vue&type=template&id=7e21d22a&"
import script from "./RoleContainer.vue?vue&type=script&lang=js&"
export * from "./RoleContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports